$(document).ready(function () {
    updateTickers();
    setInterval(() => updateTickers(), 60000);
});

function updateTickers() {
    const symbols = ['BTCUSDT', 'ETHUSDT'];

    for (let i = 0; i < 2; i++) {
        /**
         * @property data.lastPrice
         * @property data.priceChangePercent
         */
        $.get('/ticker/' + symbols[i], function (data) {
            const ticker = Math.round(data.lastPrice);
            const funding = parseFloat(data.priceChangePercent).toFixed(2);

            const block = $('[data-symbol="'+symbols[i]+'"]');
            block.find('.ticker').children('.val').text(ticker);
            block.children('.funding').removeClass('minus').removeClass('plus')
                .addClass(funding >= 0 ? 'plus' : 'minus')
                .children('.val').text(funding);
            block.show();

            block.each((index, item) => {
                const $item = $(item);
                const liquidation = parseFloat($item.find('.liquidation').text());

                if (liquidation) {
                    const stability = Math.abs((ticker - liquidation) / ticker) * 100;
                    if (stability <= 100) {
                        $item.find('.stability').text(`${stability.toFixed(2)}%`);
                    }
                }
            });
        });
    }
}

function subscribeTickers() {
    let socket = new WebSocket("wss://fstream.binance.com/ws/BTCUSDT@markPrice");
    let blocks = {
        'BTCUSDT': '[data-symbol="BTCUSDT"]',
        'ETHUSDT': '[data-symbol="ETHUSDT"]'
    };

    socket.onmessage = function(event) {
        let data = JSON.parse(event.data);
        let ticker = Math.round(data.p);

        $(blocks[data.s]).children('.ticker').children('.val').text(ticker);
    };
    socket.onopen = function() {
        socket.send('{"method": "SUBSCRIBE", "params": ["btcusdt@markPrice", "ethusdt@markPrice"], "id": 1}');
    };
}
